<template>
    <!-- main start  -->
    <div id="main">
        <!-- Main Header -->
        <MainHeader />

        <!-- Top Header -->
        <div class="top-header top-header-half">
            <div class="page-subtitle">
                <span>{{ project ? project.title : 'Project' }}</span>
            </div>
            <router-link to="/contact" class="single-page-fixed-row-link">
                <i class="fal fa-envelope"></i> <span>Get In Touch</span>
            </router-link>
        </div>
        <!-- top-header end-->

        <!-- wrapper  -->
        <div id="wrapper">
            <!-- content-holder  -->
            <div class="content-holder" data-pagetitle="Project">
                <!-- Navigation -->
                <Navigation />

                <!-- content-->
                <div class="content">
                    <!--fixed-column-wrap-->
                    <div class="fixed-column-wrap init_fx-column fcw_mob-hidden" v-if="project && project.featured_image">
                        <div class="fixed-column-wrap-content">
                            <div class="fixed-column-wrap_bg">
                                <div class="bg bg-scroll" :data-bg="project.featured_image"></div>
                                <div class="overlay"></div>
                                <div class="column-image-anim"></div>
                                <div class="hero-scroll-down-notifer">
                                    <div class="scroll-down-wrap">
                                        <div class="mousey">
                                            <div class="scroller"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="fixed-column-wrap_title">
                                <h2><span>{{ project.title }}</span></h2>
                            </div>
                            <div class="scroll-notifer">Scroll Down</div>
                        </div>
                    </div>
                    <!--fixed-column-wrap end-->

                    <!--column-wrap-->
                    <div class="column-wrap">
                        <div class="column-wrap-container white-bg fl-wrap">
                            <div class="col-wc_dec"></div>

                            <!-- Loading State -->
                            <section v-if="loading" class="scroll-con-sec">
                                <div class="container">
                                    <div class="section-title fl-wrap">
                                        <h2>Loading...</h2>
                                    </div>
                                </div>
                            </section>

                            <!-- Error State -->
                            <section v-else-if="error" class="scroll-con-sec">
                                <div class="container">
                                    <div class="section-title fl-wrap">
                                        <h2>{{ error }}</h2>
                                        <div class="sec-title_dec"></div>
                                    </div>
                                    <div class="column-wrapper_text fl-wrap">
                                        <router-link :to="`/projects/${categorySlug}`" class="btn float-btn">
                                            <span>Back to Category</span>
                                        </router-link>
                                    </div>
                                </div>
                            </section>

                            <!-- Project Content -->
                            <section v-else-if="project" id="sec1" class="scroll-con-sec">
                                <div class="container">
                                    <div class="section-title fl-wrap">
                                        <h2>{{ project.title }}</h2>
                                        <p v-if="project.description">{{ project.description }}</p>
                                        <div class="sec-title_dec"></div>
                                    </div>

                                    <div v-html="project.content"></div>
                                </div>
                                <div class="section-number">
                                    <span>0</span>1<strong>.</strong>
                                </div>
                            </section>

                            <!-- Gallery -->
                            <section
                                v-if="project && project.attachments && project.attachments.length"
                                class="scroll-con-sec gray-bg"
                                id="sec2"
                            >
                                <div class="container">
                                    <div class="section-title fl-wrap">
                                        <h2>Gallery</h2>
                                        <div class="sec-title_dec"></div>
                                    </div>
                                    <div class="row lightgallery">
                                        <div class="col-md-4" v-for="attachment in project.attachments" :key="attachment.id" style="margin-bottom:20px;">
                                            <a :href="attachment.url" class="popup-image" style="display:block; height:220px; overflow:hidden;">
                                                <img
                                                    :src="attachment.thumbnail_url || attachment.url"
                                                    :alt="attachment.description || project.title"
                                                    style="width:100%; height:100%; object-fit:cover;"
                                                >
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="section-number"><span>0</span>2<strong>.</strong></div>
                            </section>
                        </div>
                        <!--column-wrap-container end-->
                    </div>
                    <!--column-wrap end-->
                    <div class="limit-box fl-wrap"></div>
                </div>
                <!-- content end  -->

                <!-- Footer -->
                <AppFooter />
            </div>
            <!-- content-holder end -->
        </div>
        <!-- wrapper end -->
    </div>
    <!-- Main end -->
</template>

<script>
import MainHeader from '@/components/MainHeader.vue'
import Navigation from '@/components/Navigation.vue'
import AppFooter from '@/components/Common/AppFooter.vue'

export default {
    name: 'ProjectDetail',
    components: {
        MainHeader,
        Navigation,
        AppFooter
    },
    data() {
        return {
            project: null,
            loading: true,
            error: null
        }
    },
    computed: {
        categorySlug() {
            return this.$route.params.categorySlug
        },
        projectSlug() {
            return this.$route.params.projectSlug
        }
    },
    async mounted() {
        await this.loadProject()
        this.$nextTick(() => {
            setTimeout(() => this.processBackgrounds(), 300)
        })
    },
    watch: {
        async '$route'() {
            await this.loadProject()
            this.$nextTick(() => {
                setTimeout(() => this.processBackgrounds(), 300)
            })
        }
    },
    methods: {
        async loadProject() {
            this.loading = true
            this.error = null

            try {
                const response = await this.$api.get(`public/content/${this.categorySlug}/${this.projectSlug}`)
                this.project = response.data && response.data.data
                if (!this.project) {
                    this.error = 'Project not found'
                } else {
                    document.title = this.project.title
                }
            } catch (error) {
                console.error('Failed to load project:', error)
                this.error = 'Project not found'
            } finally {
                this.loading = false
            }
        },

        processBackgrounds() {
            const $ = window.jQuery
            if (!$) return

            $('[data-bg]').each(function () {
                const bg = $(this).attr('data-bg')
                if (bg) {
                    $(this).css('background-image', 'url(' + bg + ')')
                }
            })

            if ($('.fixed-column-wrap').length) {
                $('.fixed-column-wrap').css({
                    height: $(window).outerHeight(true)
                })
            }

            if ($.fn.lightGallery && $('.lightgallery').length) {
                $('.lightgallery').lightGallery({
                    selector: 'a.popup-image',
                    cssEasing: 'cubic-bezier(0.25, 0, 0.25, 1)',
                    download: false,
                    counter: false
                })
            }
        }
    }
}
</script>
